import React from 'react';
import QuestionStatus from '../questions/QuestionStatus';
import TriviaState from '../questions/TriviaState';
import CustomCheckbox from '../generalComponets/CustomCheckbox';

function ProfileItem({ profile, showQuestionStatus, triviaState, checked, setValue }) {
  return (
    <div className="card">
      <div className="card-content">
        <div className="row">
          <div className="col s8">
            <h6>Name: {profile.name}</h6>
            <h6>Email: {profile.email}</h6>
            <h6>Id: {profile.id}</h6>
            <h6>Country: {profile.countryCode}</h6>
            <h6>State: {profile.stateCode}</h6>
            {showQuestionStatus ? <QuestionStatus profile={profile} /> : <div />}
            {triviaState ? <TriviaState profile={profile} /> : <div />}
          </div>
          <CustomCheckbox value={checked} setValue={setValue} />
        </div>
      </div>
    </div>
  );
}

export default ProfileItem;
